import { LOCAL_STORAGE_QUERY_KEY } from './App';
import {
  GetWordsParams,
  GetWordsResponse,
  GetWordsResponseError,
} from './types';

export default class Api {
  static GET_URL: string = '/api/words';

  static async fetch<R = unknown>(
    url: string,
    options?: RequestInit,
  ): Promise<R> {
    const response: Response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        `${response.status} - ${
          ((await response.json()) as GetWordsResponseError).message
        }`,
      );
    }

    return response.json() as Promise<R>;
  }

  static makeQueryString(
    params: Record<string, string | number | boolean>,
  ): string {
    let queryString: string = '';

    for (const [key, value] of Object.entries(params)) {
      if (!value) {
        continue;
      }

      // transforms camelCase to snake_case and removes `is` if present
      const transformedKey: string = key.replace(
        /is([A-Z])|[A-Z]/g,
        (match, group: string) =>
          group ? group.toLowerCase() : `_${match.toLowerCase()}`,
      );
      const symbol: string = !queryString ? '?' : '&';

      queryString += `${symbol}${transformedKey}=${encodeURIComponent(value)}`;
    }

    return queryString;
  }

  static async getWords(
    params: GetWordsParams,
    saveQuery: boolean,
  ): Promise<GetWordsResponse> {
    if (saveQuery) {
      localStorage.setItem(LOCAL_STORAGE_QUERY_KEY, JSON.stringify(params));
    } else {
      localStorage.setItem(LOCAL_STORAGE_QUERY_KEY, '');
    }

    const query: string = this.makeQueryString(params);
    const url: string = `${this.GET_URL}${query}`;
    let result: GetWordsResponse;

    try {
      result = await this.fetch(url);
    } catch (error) {
      console.error(error);

      return {
        page: 0,
        pages: [],
        range: '0 - 0',
        total: 0,
        words: [],
      };
    }

    return result;
  }
}
